/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 * 
 *  [2007] - [2016] Counterpoint Consulting, Incorporated 
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

const Backgrid = require('backgrid');
const _ = require('lodash');


const ExpandableCell = Backgrid.Cell.extend({
    events: {
        'click .more-link': 'onMoreLinkClicked',
        'click .collapse-link': 'onCollapseLinkClicked',
    },

    onMoreLinkClicked(e) {
        const $moreLink = this.$(e.currentTarget);
        const $collapseDiv = $moreLink.parent().next('.collapse');

        $collapseDiv.slideDown(() => {
            this.$('.collapse-link').removeClass('hide');
            this.$('.more-link').hide()

        });

        $moreLink.attr('row-expanded', 'false');
    },

    onCollapseLinkClicked(e) {
        const $collapseLink = this.$(e.currentTarget);
        const $collapseDiv = $collapseLink.closest('.collapse');

        $collapseDiv.slideUp(() => {
            $collapseLink.addClass('hide');
            this.$('.more-link').show()
        });
        this.$('.more-link').attr('row-expanded', 'true');

    },

    render() {
        this.$el.addClass('expandable-cell');
        let template = '<div>';
        const column = this.column.get('name');

        const data = this.model.get(column);

        if (data) {
            if (data.length === 1) {
                this.$el.html(data[0]);
                return this;
            } else {
                _.forEach(data, (val, index) => {
                    template = `${template}<p>${val}</p>`;
                    if (index === 0 && data.length > 1) {
                        template = `${template}<a class="more-link" row-expanded="true">More</a></div><div class="collapse" name="more">`;
                    }

                    if (index !== 0 && index === data.length - 1) {
                        template = `${template}<p><a class="text-danger collapse-link" row-expanded="false">Collapse</a></p></div>`;
                    }
                });

                this.$el.html(template);
                return this;
            }
        } else {
            return this;
        }
    },
});

export default ExpandableCell;
